import UserInfoService from 'src/utils/UserInfoService';
import {
  cancelRegisterAutoDebitAPI,
  getAutoDebitsAPI,
  getListAllPolicy,
  getPeriodicPolicyByPolicyNum,
  registerAutoDebitAPI,
} from '../api';
import LoadingService from '../utils/LoadingService';
import loadingService from '../utils/LoadingService';
import { CONSTANT } from 'src/constants';
import { randomNumber, showContact, showError } from 'src/utils';
import { convertPolicyStatusToPolicyStatusId } from 'src/utils/Policy';
import { AutoDebitItem } from 'src/models/AutoDebit';

export class AutoPaymentStore {
  policies: any[] = [];
  autoDebits: AutoDebitItem[] = [];

  async getAutoDebits(
    loading = true,
  ): Promise<AutoDebitItem[]> {
    loading && LoadingService.instance.current.open();
    try {
      let res = await getAutoDebitsAPI();
      this.autoDebits = res.data;
      return Promise.resolve(res.data as AutoDebitItem[]);
    } catch (error) {
      this.handleError(error);
      return Promise.reject(error);
    } finally {
      loading && LoadingService.instance.current.close();
    }
  }

  async getPolicies(
    loading = true
  ) {
    try {
      loading && LoadingService.instance.current.open();
      let response = await getListAllPolicy(
        UserInfoService.getUserInfo()?.idCardType ?? CONSTANT.ID_CARD_TYPE_DEFAULT,
        UserInfoService.getUserInfo()?.idCardNo ?? CONSTANT.ID_CARD_NO_DEFAULT,
        UserInfoService.getUserInfo()?.dob ?? CONSTANT.DOB_DEFAULT,
      );
      let data = response.data.map(item => {
        return {
          ...item,
          bgIndex: randomNumber(0, 1),
        };
      });
      this.policies = response.data;
      return Promise.resolve(data);
    } catch (error) {
      this.handleError(error);
      return Promise.resolve(error);
    } finally {
      loading &&  LoadingService.instance.current.close();
    }
  }

  async getPeriodicPolicy({ policyNumber, bgIndex }: { policyNumber: number, bgIndex?: number }) {
    try {
      loadingService.instance.current.open();
      let response = await getPeriodicPolicyByPolicyNum(policyNumber);
      let data = {
        ...response.data,
        bgIndex: bgIndex ?? randomNumber(0, 1),
      };
      if (!data.policyStatusId) {
        data.policyStatusId = convertPolicyStatusToPolicyStatusId(data.policyStt);
      }
      if (data.duePremium?.length > 0) {
        data.duePremium[0].checked = true;
      }
      if (!data.payFrequency) {
        data.payFrequency = data.payFreqText;
      }
      if (!data.periodicPremium) {
        data.periodicPremium = data.periodicPrem;
      }
      return Promise.resolve(data);
    } catch (error) {
      let errorStatus = error?.response?.status;
      if (errorStatus == 400) {
        let errorCodes = ['005', '207'];
        let errorCode = error?.response?.data?.error_code;
        let errorMessage = error?.response?.data?.error_message;
        if (errorCodes.includes(errorCode)) {
          showContact(errorMessage);
        } else {
          showError(errorMessage);
        }
      }
      return Promise.reject(error);
    } finally {
      loadingService.instance.current.close();
    }
  }


  async registerAutoDebit(body: Parameters<typeof registerAutoDebitAPI>[0]) {
    LoadingService.instance.current.open();
    try {
      let res = await registerAutoDebitAPI(body);
      return Promise.resolve(res.data);
    } catch (error) {
      this.handleError(error);
      return Promise.reject(error);
    } finally {
      LoadingService.instance.current.close();
    }
  }

  async cancelRegisterAutoDebit(
    body: Parameters<typeof cancelRegisterAutoDebitAPI>[0],
  ) {
    LoadingService.instance.current.open();
    try {
      let res = await cancelRegisterAutoDebitAPI(body);
      return Promise.resolve(res.data);
    } catch (error) {
      this.handleError(error);
      return Promise.reject(error);
    } finally {
      LoadingService.instance.current.close();
    }
  }

  handleError(error?: any) {
    let errorMessage = error?.response?.data?.error_message;
    showError(errorMessage);
  }
}

export default new AutoPaymentStore();
